import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  type CreateUserMutationError,
  getListUsersQueryKey,
  useCreateUser,
} from '@/entities/tenantusers/api/generated/api';
import { ErrorResponseErrorCode } from '@/entities/tenantusers/api/generated/model';
import { toast } from '@/shared/ui';

export const useUserCreateMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const userTitle = t('user-management.navigation.title');

  return useCreateUser({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(t('common.messages.create-success', { name: userTitle }));
        queryClient.invalidateQueries({ queryKey: getListUsersQueryKey() });
        onSuccess();
      },
      onError: (error: CreateUserMutationError) => {
        const data = error.response?.data;
        if (data?.error_code === ErrorResponseErrorCode.UNIQUE_CONSTRAINT_ERROR) {
          toast.error(t('user-management.users.create.error.duplicate-email'));
          return;
        }
        // VALIDATION_ERROR は BE が動的に具体的な理由を message に詰めるため、そのまま表示する
        if (data?.error_code === ErrorResponseErrorCode.VALIDATION_ERROR && data.message) {
          toast.error(data.message);
          return;
        }
        toast.error(t('common.messages.create-failed', { name: userTitle }));
      },
    },
  });
};
